export default __webpack_public_path__ + "static/media/delivered.6bec98cc.svg";